"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AppLocale = /** @class */ (function () {
    function AppLocale() {
    }
    AppLocale.getRangeSelectLocale = function () {
        return {
            lang: {
                placeholder: "Выберите дату",
                rangePlaceholder: [
                    "Дата начала",
                    "Дата окончания"
                ],
                today: "Today",
                now: "Now",
                backToToday: "Back to today",
                ok: "Ok",
                clear: "Clear",
                month: "Month",
                year: "Year",
                timeSelect: "Select time",
                dateSelect: "Select date",
                monthSelect: "Choose a month",
                yearSelect: "Choose a year",
                decadeSelect: "Choose a decade",
                yearFormat: "YYYY",
                dateFormat: "M/D/YYYY",
                dayFormat: "D",
                dateTimeFormat: "M/D/YYYY HH:mm:ss",
                monthFormat: "MMMM",
                monthBeforeYear: true,
                previousMonth: "Previous month (PageUp)",
                nextMonth: "Next month (PageDown)",
                previousYear: "Last year (Control + left)",
                nextYear: "Next year (Control + right)",
                previousDecade: "Last decade",
                nextDecade: "Next decade",
                previousCentury: "Last century",
                nextCentury: "Next century"
            },
            "timePickerLocale": {
                "placeholder": "Выберите время"
            }
        };
    };
    return AppLocale;
}());
exports.AppLocale = AppLocale;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/shared/locale/AppLocale.ts
// module id = 1747
// module chunks = 0